import { enqueueSnackbar } from "notistack";
import apiConfig from "../../../services/apiManager/apiConfig";
import {
  getRequestAuthenticationRequest,
  postAuthenticationRequest,
  postAuthenticationRequestForAgreement,
  putAuthenticationRequest,
} from "../../../services/apiManager/apiRequests";
import {
  CHANGE_STATUS_FAILURE,
  CHANGE_STATUS_REQUEST,
  CHANGE_STATUS_SUCCESS,
  CREATE_AGREEMENT_FAILURE,
  CREATE_AGREEMENT_REQUEST,
  CREATE_AGREEMENT_SUCCESS,
  DECLINE_AGREEMENT_FAILURE,
  DECLINE_AGREEMENT_REQUEST,
  DECLINE_AGREEMENT_SUCCESS,
  FETCH_ADOBE_DOCUMENT_FAILURE,
  FETCH_ADOBE_DOCUMENT_REQUEST,
  FETCH_ADOBE_DOCUMENT_SIGNED_SUCCESS,
  FETCH_ADOBE_DOCUMENT_UNSIGNED_SUCCESS,
  FETCH_PDF_FAILURE,
  FETCH_PDF_REQUEST,
  FETCH_PDF_SUCCESS,
  INCREMENT_INTERVAL_COUNTER,
} from "../constants";
import SnackbarConfig from "../../../utils/snackbarConfig";
import storePersist, { localConstant } from "../../../services/localStorage";

export const fetchPdf =
  (customerId, userId, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: FETCH_PDF_REQUEST,
        payload: { isLoading: true },
      });
      const response = await postAuthenticationRequestForAgreement(
        `${apiConfig.getPdfDocument}${customerId}/user/${userId}/document`,
        null,
        null,
        "application/json",
        "application/json",
      );
      if (response?.url) {
        dispatch({
          type: FETCH_PDF_SUCCESS,
          payload: response,
        });
        callback(response);
      } else {
        enqueueSnackbar("Failed to fetch agreement preview", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
        dispatch({
          type: FETCH_PDF_FAILURE,
          payload: { isLoading: false },
        });
        callback(response);
      }
    } catch (error) {
      enqueueSnackbar("Failed to fetch agreement preview", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback(error);
      dispatch({
        type: FETCH_PDF_FAILURE,
        payload: { isLoading: false },
      });
    }
  };

export const createAgreement =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: CREATE_AGREEMENT_REQUEST,
        payload: { isLoading: true },
      });
      const requestBody = {
        agreementName: "reservation",
        callBackUrl: null,
        expirationDate:
          new Date(Date.now() + 30 * 86400000).toISOString().split(".")[0] +
          "Z",
        state: "OUT_FOR_SIGNATURE",
        fileInfos: [
          {
            name: "T&C",
            url: params?.pdfUrl,
          },
        ],
        participantSets: [
          {
            participants: [
              {
                name: params?.name,
                email: params?.email,
                assignedFormFields: ["Signature1"],
              },
            ],
          },
        ],
        formFields: {
          prefilledValues: {
            lot_number: {
              value: "vin2334",
              required: true,
              readOnly: true,
            },
            lot_vin: {
              value: "898",
              required: true,
              readOnly: false,
            },
            lot_year: {
              value: "2019",
              required: true,
            },
            lot_make: {
              value: "Toyota",
              required: true,
            },
            checkbox_field: {
              value: "yes",
              required: true,
            },
            radio_field: {
              value: "option name",
              required: true,
            },
          },
        },
        custId: storePersist.get(localConstant.ENTITY_CUSTOMER_ID),
        userId: storePersist.get(localConstant.USER_ID),
      };
      const response = await postAuthenticationRequestForAgreement(
        apiConfig.createAgreement,
        requestBody,
        null,
        "application/json",
        "application/json",
      );
      if (response?.response?.agreementId) {
        dispatch({
          type: CREATE_AGREEMENT_SUCCESS,
          payload: response?.response?.agreementId,
        });
        storePersist.set(
          localConstant.AGREEMENT_ID,
          response?.response?.agreementId,
        );
        callback(response);
      } else {
        enqueueSnackbar("Failed to create agreement", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
        dispatch({
          type: CREATE_AGREEMENT_FAILURE,
          payload: { isLoading: false },
        });
        callback(response);
      }
    } catch (error) {
      enqueueSnackbar("Failed to create agreement", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback(error);
      dispatch({
        type: CREATE_AGREEMENT_FAILURE,
        payload: { isLoading: false },
      });
    }
  };

export const getAdobeDocument =
  (id, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: FETCH_ADOBE_DOCUMENT_REQUEST,
        payload: { isLoading: true },
      });
      const response = await getRequestAuthenticationRequest(
        `${apiConfig.getAgreement}${id}`,
        null,
      );
      if (response?.response?.agreementStatus) {
        if (response?.response?.agreementStatus === "OUT_FOR_SIGNATURE") {
          dispatch({
            type: FETCH_ADOBE_DOCUMENT_UNSIGNED_SUCCESS,
            payload: response,
          });
          callback(response);
        } else if (
          response?.response?.agreementStatus === "COMPLETED" ||
          response?.response?.participant?.[0]?.signStatus === "SIGNED"
        ) {
          dispatch({
            type: FETCH_ADOBE_DOCUMENT_SIGNED_SUCCESS,
            payload: response,
          });
          callback(response);
        } else if (
          response?.response?.agreementStatus === "IN_PROGESS" ||
          response?.response?.participant?.[0]?.signStatus === "IN_PROGESS"
        ) {
          dispatch({
            type: FETCH_ADOBE_DOCUMENT_UNSIGNED_SUCCESS,
            payload: response,
          });
          callback(response);
        }
      } else {
        enqueueSnackbar("Failed to fetch agreement", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
        dispatch({
          type: FETCH_ADOBE_DOCUMENT_FAILURE,
          payload: { isLoading: false },
        });
        callback(response);
      }
    } catch (error) {
      enqueueSnackbar("Failed to fetch agreement", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback(error);
      dispatch({
        type: FETCH_ADOBE_DOCUMENT_FAILURE,
        payload: { isLoading: false },
      });
    }
  };

export const changeStatusToSignInProgress =
  (id, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: CHANGE_STATUS_REQUEST,
      });
      const response = await putAuthenticationRequest(
        `${apiConfig.updateStatus}${id}/status?agreementStatus=IN_PRGRS`,
        null,
      );
      if (response?.statusCode === 200) {
        dispatch({
          type: CHANGE_STATUS_SUCCESS,
          payload: response,
        });
        callback(response);
      } else {
        dispatch({
          type: CHANGE_STATUS_FAILURE,
        });
      }
    } catch (error) {
      callback(error);
      dispatch({
        type: CHANGE_STATUS_FAILURE,
      });
    }
  };

export const changeStatusToDeclined =
  (customerId, userId, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: DECLINE_AGREEMENT_REQUEST,
      });
      const response = await postAuthenticationRequest(
        `${apiConfig.declineAgreement}${customerId}/user/${userId}/regenerate`,
        null,
        null,
      );
      if (response?.statusCode === 201) {
        storePersist.set(
          localConstant.AGREEMENT_ID,
          response?.response?.agreementId,
        );
        dispatch({
          type: DECLINE_AGREEMENT_SUCCESS,
          payload: response,
        });
        callback(response);
      } else {
        dispatch({
          type: DECLINE_AGREEMENT_FAILURE,
        });
        callback({});
      }
    } catch (error) {
      callback(error);
      dispatch({
        type: DECLINE_AGREEMENT_FAILURE,
      });
    }
  };

export const setIntervalCounter = (counter) => ({
  type: INCREMENT_INTERVAL_COUNTER,
  payload: counter,
});
